<template>
  <div class="invite-wrap">
    <div class="main">
      <div class="invite-header">
        <div class="header-sub-title">
          <img
            src="../../static/img/new-invite/text-yaoqinghaoyou.png"
            class="sub-title"
            alt=""
          />
        </div>
        <div class="header-title">
          <img
            src="../../static/img/new-invite/text-yuer.png"
            class="title"
            alt=""
          />
        </div>
        <div class="header-desc-box">
          <div class="header-desc" v-if="sysConfigCoupon">
            每邀请 1 名好友注册，可获得 ¥{{
              sysConfigCoupon.register_balance / 100
            }}
            余额
          </div>
        </div>
        <div class="header-rule" @click="gotoRule">活动规则</div>
      </div>
      <div class="balance-amount-section">
        <div class="content">
          <div class="amount-box">
            <span class="unit">￥</span>
            <span class="num" v-if="sysConfigCoupon">{{
              (sysConfigCoupon.register_balance *
                sysConfigCoupon.register_max_times) /
              100
            }}</span>
            <span class="desc">余额</span>
          </div>
          <div class="label">余额可用于办理签证</div>
        </div>
        <div class="btn-box">
          <div class="btn" @click="share">去邀请好友</div>
        </div>
      </div>

      <!-- <div class="invite-coupon-section" v-if="sysConfigCoupon">
        被邀请的好友可获得 ￥{{sysConfigCoupon.cash_reduce / 100}} 优惠券
      </div> -->

      <div class="invite-record-wrap">
        <div class="invite-record">
          <div class="title">奖励明细</div>
          <div class="record-num-box" v-if="mobile_phone">
            累计获得 <span>￥{{ inviteInfo.balance_amount / 100 }}</span
            >，成功注册
            <span>{{ inviteInfo.register_count }}</span> 人，成功付款
            <span>{{ inviteInfo.pay_count }}</span> 人
          </div>
          <div class="record-list-box">
            <div class="recode-not-login" v-if="!mobile_phone">
              <img src="../../static/img/new-invite/icon-panda.png" alt="" />
              <div class="desc">哎呀，我还没有登录</div>
            </div>
            <ul
              class="recode-list"
              v-else-if="
                inviteInfo.user_balance && inviteInfo.user_balance.length > 0
              "
            >
              <template v-for="(item, index) in inviteInfo.user_balance">
                <li class="recode-item" :key="index" v-if="index < 5">
                  <div class="recode-item-icon">
                    <img
                      src="../../static/img/new-invite/register-m.png"
                      v-if="item.balance_type == 2"
                    />
                    <img
                      src="../../static/img/new-invite/pay-m.png"
                      v-if="item.balance_type == 1"
                    />
                  </div>
                  <div class="recode-item-content">
                    <div class="reason">{{ item.reason }}</div>
                    <div class="time">{{ item.create_time }}</div>
                    <div class="recode-item-amount" v-if="item.balance > 0">
                      <div class="unit-box"><span class="add">+</span>￥</div>
                      {{ item.balance / 100 }}
                    </div>
                  </div>
                </li>
              </template>
              <div
                class="recode-read-more-box"
                v-if="inviteInfo.user_balance.length > 5"
              >
                <div class="recode-read-more" @click="goBalance">
                  查看更多
                  <img
                    src="../../static/img/new-invite/icon-right.png"
                    class="read-more-icon"
                    alt=""
                  />
                </div>
              </div>
            </ul>
            <div class="recode-null" v-else>
              <img src="../../static/img/new-invite/icon-panda.png" alt="" />
              <div class="desc">还没获得任何奖励哟<br />赶紧邀请好友加入吧</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <invite-share
      v-if="sysConfigCoupon && shareParam && mobile_phone"
      :mobilePhone="mobile_phone"
      :price="sysConfigCoupon.cash_reduce / 100"
      :shareParam="shareParam"
      v-model="shareData"
    >
    </invite-share>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import utils from '../services/tools.js';
import InviteService from '../services/inviteService.js';
import toast from '../services/toast.js';
import inviteShare from '../components/inviteShare';
import systemService from '../services/systemService';

export default {
  name: 'inviteInApp',
  data() {
    return {
      mobile_phone: '',
      inviteInfo: {
        user_balance: [],
      },
      shareData: null,
      inviteService: new InviteService(this.$http),
      sysConfigCoupon: null,
      shareParam: null,
    };
  },
  components: {
    inviteShare,
  },
  methods: {
    /**
     * 获取用户编号
     */
    getUID() {
      this.mobile_phone = parseInt(this.$route.query.mobile_phone);
    },

    /**
     * 获取系统配置
     */
    sysConfigGet() {
      systemService.sysConfigGet().then((data) => {
        this.sysConfigCoupon = data.coupon;
      });
    },

    /**
     * 获取邀请信息
     */
    getInviteInfo() {
      this.inviteService
        .queryUserInviteInfo(this.mobile_phone)
        .then((data) => {
          const result = data.body;

          if (result.ret === 0) {
            this.inviteInfo = result.body;
            // 进入页面的埋点，两种情况，进来的时候就有手机号，或者进来后在登录也会进行一次埋点
            sensorsdata.track('invitation_page', {
              platform_type: 'HTML5',
              ...(this.inviteInfo.user_account_id && {
                user_account_id: this.inviteInfo.user_account_id,
              }),
            });
          } else {
            toast.show(result.msg);
          }
        })
        .catch(() => toast.show('获取失败'));
    },
    // 获取分享的信息
    getShareParam() {
      this.inviteService
        .getShareParam()
        .then((data) => {
          const result = data.body;

          if (result.ret === 0) {
            this.shareParam = result.body;
          } else {
            toast.show(result.msg);
          }
        })
        .catch(() => toast.show('获取失败'));
    },

    /**
     * 分享
     */
    share() {
      if (!this.mobile_phone) {
        utils.getBridge((bridge) => {
          bridge.callHandler('open_login', {}, () => {});
        });
        return;
      }
      if (!this.sysConfigCoupon || !this.shareData) {
        toast.show('获取数据失败');
        return;
      }

      utils.getBridge((bridge) => {
        sensorsdata.track('invitation_invite', {
          platform_type: 'HTML5',
          ...(this.inviteInfo.user_account_id && {
            user_account_id: this.inviteInfo.user_account_id,
          }),
        });
        bridge.callHandler(
          'invite_client_share',
          { image: this.shareData },
          () => {},
        );
      });
    },

    /**
     * 跳转app余额
     */
    goBalance() {
      utils.getBridge((bridge) => {
        sensorsdata.track('invitation_details_more', {
          platform_type: 'HTML5',
          ...(this.inviteInfo.user_account_id && {
            user_account_id: this.inviteInfo.user_account_id,
          }),
        });
        bridge.callHandler('navigateToBalance', {}, () => {});
      });
    },
    /**
     * 跳转活动规则
     */
    gotoRule() {
      if (!this.mobile_phone) {
        utils.getBridge((bridge) => {
          bridge.callHandler('open_login', {}, () => {});
        });
        return;
      }
      sensorsdata.track('invitation_rule', {
        platform_type: 'HTML5',
        ...(this.inviteInfo.user_account_id && {
          user_account_id: this.inviteInfo.user_account_id,
        }),
      });
      this.$router.push('/invite-rule');
    },
    // 往当前URL里面添加query参数
    addQueryToUrl(key, value) {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      query[key] = value;
      let queryString = '';
      Object.keys(query).forEach((key) => {
        queryString += `${key}=${query[key]}&`;
      });
      queryString = queryString.substring(0, queryString.length - 1);
      window.location.replace(
        `${window.location.origin}/#${this.$route.path}?${queryString}`,
      );
    },
    initRegisterBridge() {
      utils.getBridge((bridge) => {
        // 安卓初始化
        if (utils.getOS() === 'android') {
          bridge.init((message, responseCallback) => {
            responseCallback({
              bridgeReady: 'ok',
            });
          });
        }
        // 给app调用,给H5当前登录的手机号
        bridge.registerHandler('mobile_phone', (data) => {
          if (data) {
            this.mobile_phone = data;
            this.addQueryToUrl('mobile_phone', this.mobile_phone);
            this.getInviteInfo();
          }
        });
      });
    },
  },
  mounted() {
    this.sysConfigGet();
    this.getUID();
    this.getShareParam();
    if (this.mobile_phone) {
      this.getInviteInfo();
    } else {
      // 进入页面埋点
      sensorsdata.track('invitation_page', {
        platform_type: 'HTML5',
        ...(this.inviteInfo.user_account_id && {
          user_account_id: this.inviteInfo.user_account_id,
        }),
      });
    }
  },
  created() {
    utils.setTitle('邀请拿奖励');
    this.initRegisterBridge();
  },
};
</script>

<style lang="less" scoped>
@import '../styles/theme.less';

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  line-height: 1;
}

img {
  max-width: 100%;
}

.invite-wrap {
  min-height: 100%;
  letter-spacing: 0.0015rem;
}

.main {
  background: url(../../static/img/new-invite/main-bg.png) #ffcdcc no-repeat top
    left;
  background-size: 100%;
  min-height: 100vh;
  padding-bottom: 0.64rem;
}

.invite-header {
  padding-top: 0.5rem;
  margin-bottom: 0.07rem;
  text-align: center;
  line-height: 1;
  position: relative;
  .header-sub-title {
    margin-bottom: 0.16rem;
    .sub-title {
      width: 2.5rem;
    }
  }
  .header-title {
    margin-bottom: 0.16rem;
    .title {
      width: 2.51rem;
    }
  }
  .header-desc-box {
    text-align: center;
    .header-desc {
      display: inline-block;
      font-size: 0.17rem;
      color: #bb4d4d;
      position: relative;
      &::after {
        content: '';
        background: url(../../static/img/new-invite/line-right.png) no-repeat;
        background-size: 100% 100%;
        width: 0.225rem;
        height: 1px;
        position: absolute;
        right: -0.265rem;
        top: 50%;
      }
      &::before {
        content: '';
        background: url(../../static/img/new-invite/line-right.png) no-repeat;
        background-size: 100% 100%;
        width: 0.225rem;
        height: 1px;
        position: absolute;
        left: -0.265rem;
        top: 50%;
        transform: rotate(-180deg);
      }
    }
  }

  .header-rule {
    position: absolute;
    right: 0;
    top: 0.14rem;
    font-size: 0.14rem;
    width: 0.76rem;
    height: 0.24rem;
    background-color: #ff4b4d;
    border-radius: 0.12rem 0rem 0rem 0.12rem;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.balance-amount-section {
  margin: auto;
  width: 3.44rem;
  height: 3.53rem;
  background: url(../../static/img/new-invite/red-packet.png) no-repeat;
  background-size: 100% 100%;
  .content {
    text-align: center;
    padding-top: 0.8rem;
    height: 2rem;
    line-height: 1;
    .amount-box {
      padding-top: 0.1rem;
      color: #ef2a27;
      .unit {
        font-size: 0.24rem;
        display: inline-block;
        transform: translateY(-0.02rem);
      }
      .num {
        font-size: 0.84rem;
      }
      .desc {
        font-size: 0.2rem;
        display: inline-block;
        transform: translateY(-0.05rem);
      }
    }
    .label {
      font-size: 0.12rem;
      color: #ea9492;
      margin-top: 0.05rem;
    }
  }
  .btn-box {
    margin-top: 0.5rem;
    height: 0.8rem;
    text-align: center;
    padding-top: 0.05rem;
    .btn {
      width: 1.9rem;
      height: 0.45rem;
      background-image: linear-gradient(-30deg, #ffda6f 0%, #ffeb95 100%);
      box-shadow: 0rem 0.08rem 0.24rem 0rem #d92011,
        inset 0rem 0.02rem 0.16rem 0rem rgba(255, 207, 68, 0.6);
      border-radius: 0.23rem;
      color: #954729;
      font-size: 0.2rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.invite-coupon-section {
  text-align: center;
  font-size: 0.17rem;
  line-height: 1;
  color: #bb4d4d;
}
.invite-record-wrap {
  padding: 0 0.12rem;
  margin-top: 0.32rem;
  .invite-record {
    padding: 0.16rem 0;
    background: #fff;
    border-radius: 0.08rem;
    text-align: center;
    .title {
      font-size: 0.17rem;
      color: #333333;
    }
    .record-num-box {
      margin-top: 0.2rem;
      color: #686363;
      font-size: 0.14rem;
      span {
        color: #ff5a60;
      }
    }
    .record-list-box {
      margin-top: 0.28rem;
      .recode-not-login,
      .recode-null {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img {
          width: 1.08rem;
          height: 1.08rem;
        }
        .desc {
          margin-top: 0.1rem;
          font-size: 0.12rem;
          color: #afaaaa;
          line-height: 0.18rem;
        }
      }
      .recode-list {
        .recode-item {
          display: flex;
          align-items: center;
          padding: 0 0.12rem;
          font-size: 0;
          margin-bottom: 0.24rem;
          &:last-of-type {
            margin-bottom: 0;
          }
          .recode-item-icon {
            width: 0.4rem;
            flex-shrink: 0;
            flex-grow: 0;
          }
          .recode-item-content {
            flex-grow: 1;
            line-height: 1;
            margin-left: 0.12rem;
            position: relative;
            text-align: left;
            .reason {
              font-size: 0.14rem;
              color: #333333;
            }
            .time {
              font-size: 0.11rem;
              color: #afaaaa;
              margin-top: 0.08rem;
            }
            .recode-item-amount {
              flex-shrink: 0;
              flex-grow: 0;
              min-width: 0.4rem;
              text-align: right;
              position: absolute;
              right: 0;
              top: 0;
              font-size: 0.15rem;
              color: #ff4b4d;
              font-weight: 600;
              letter-spacing: 0;
              .unit-box {
                display: inline-block;
                transform: translateX(0.02rem);
                span {
                  display: inline-block;
                  transform: translate(0.02rem, -0.015rem);
                }
              }
            }
          }
        }
        .recode-read-more-box {
          margin-top: 0.24rem;
          .recode-read-more {
            color: #686363;
            font-size: 0.14rem;
            text-align: center;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            .read-more-icon {
              width: 0.12rem;
              height: 0.12rem;
              margin-left: 0.02rem;
            }
          }
        }
      }
    }
  }
}
</style>
